"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactHcaptcha = _interopRequireDefault(require("@hcaptcha/react-hcaptcha"));
var _core = require("@material-ui/core");
var _hooks = require("../../hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Captcha = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    onVerify: passedOnVerify,
    onExpire,
    error
  } = _ref;
  const {
    captchaSiteKey
  } = (0, _hooks.useConfig)();
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const onVerify = function () {
    setIsOpen(false);
    passedOnVerify(...arguments);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactHcaptcha.default, {
    sitekey: captchaSiteKey,
    onVerify: onVerify,
    onExpire: onExpire,
    onOpen: () => setIsOpen(true),
    onClose: () => setIsOpen(false),
    ref: ref
  }), !isOpen && /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    error: true
  }, error)));
});
var _default = exports.default = Captcha;